import { memo, useMemo } from 'react';
import WithFilter from '../../screens/common/WithFilter';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routeFileSelector } from '../../../utilz/i18n';
import SearchQuoteFilters from '../../screens/Shipment/SearchQuoteFilters';
import QuoteContent from '../../screens/Shipment/QuoteContent';
import QuoteFooter from '../../screens/Shipment/components/QuoteFooter';
import QuotePageHeader from '../../screens/Shipment/components/QuotePageHeader';

const SearchQuotePage = () => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <>
      <WithFilter
        filterElement={<SearchQuoteFilters />}
        headerContent={<QuotePageHeader />}
        contentElement={<QuoteContent />}
        filterTitle={t('translation:default.fields.filter')}
        footerContent={<QuoteFooter />}
        labelForTestId="search-quote"
        pageTitle={t('translation:searchQuote.title')}
      />
      <Outlet />
    </>
  );
};

export default memo(SearchQuotePage);
